import type { ServiceGetByIdResponse } from '@/types/service'

import type {
  RecapPoktan,
  RecapPoktanDetail,
  RecapPoktanMeta,
  RecapPoktanSummary
} from './types'

type RecordType = 'detail' | 'summary'

export type RecapPoktanRecord<TType extends RecordType> = TType extends 'detail'
  ? RecapPoktanDetail & { recordType: 'detail' }
  : RecapPoktanSummary & { recordType: 'summary' }

export type RecapPoktanData = Array<
  RecapPoktanRecord<'detail'> | RecapPoktanRecord<'summary'>
>

export interface RecapPoktanQueryResult {
  data: RecapPoktanData
  meta?: RecapPoktanMeta | null
}

type RecapPoktanApiResponse = ServiceGetByIdResponse<RecapPoktan> & {
  meta?: RecapPoktanMeta
}

export function toRecords(
  json: RecapPoktanApiResponse
): RecapPoktanQueryResult {
  const data = json.data

  if (!data) {
    return {
      data: [],
      meta: json.meta ?? null
    }
  }

  const summary = [
    {
      ...data.summary,
      recordType: 'summary'
    } satisfies RecapPoktanRecord<'summary'>
  ]

  const details = data.detail.map(
    item =>
      ({
        ...item,
        recordType: 'detail'
      }) satisfies RecapPoktanRecord<'detail'>
  )

  return {
    data: [...details, ...summary],
    meta: json.meta ?? null
  }
}
